import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const reportInfoContainerStyles = css({
  padding: theme.spacing(12, 5),
  width: '100%',
});

export const reportSectionStyles = css({ backgroundColor: theme.colors.neutral5 });
